const alphaSpecial = /^[0-9A-ZÁÉÍÑÓÚÜÄÖÜßČĎĚŇŘŠŤŮÝŽçÇèÈùÙìÌ/\-_.,;:·\sºª<>#´¨{}`"+[*^¡'¿()!$%&\]\\|]*$/i
export default {
  getMessage (field, args) {
    return field
  },
  validate (value, args) {
    return alphaSpecial.test(value)
  }
}
